
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[countryCode]/sucursal/[locationId]/profesional/[providerId]",
      function () {
        return require("private-next-pages/[countryCode]/sucursal/[locationId]/profesional/[providerId].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[countryCode]/sucursal/[locationId]/profesional/[providerId]"])
      });
    }
  